import { render, staticRenderFns } from "./CutSew.vue?vue&type=template&id=5008ec83&scoped=true"
import script from "./CutSew.vue?vue&type=script&lang=js"
export * from "./CutSew.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=5008ec83&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008ec83",
  null
  
)

export default component.exports